export enum JobOpeningStatus {
    YET_TO_OPEN = 'YET_TO_OPEN', // Planned, not yet open
    OPEN = 'OPEN', // Default; open for hiring
    ON_HOLD = 'ON_HOLD',
    CLOSED = 'CLOSED',
    OFFERED = 'OFFERED', // Linked with offer
    CANCELLED = 'CANCELLED',
}

/** Allowed next statuses from each current status (job opening state machine). */
const ALLOWED_TRANSITIONS: Record<string, string[]> = {
    [JobOpeningStatus.OPEN]: [
        JobOpeningStatus.YET_TO_OPEN,
        JobOpeningStatus.ON_HOLD,
        JobOpeningStatus.CLOSED,
        JobOpeningStatus.CANCELLED,
        JobOpeningStatus.OFFERED,
    ],
    [JobOpeningStatus.YET_TO_OPEN]: [JobOpeningStatus.OPEN, JobOpeningStatus.CLOSED, JobOpeningStatus.CANCELLED],
    [JobOpeningStatus.ON_HOLD]: [JobOpeningStatus.YET_TO_OPEN, JobOpeningStatus.OPEN, JobOpeningStatus.CLOSED, JobOpeningStatus.CANCELLED],
    [JobOpeningStatus.OFFERED]: [JobOpeningStatus.CLOSED, JobOpeningStatus.CANCELLED],
    [JobOpeningStatus.CLOSED]: [JobOpeningStatus.YET_TO_OPEN, JobOpeningStatus.OPEN, JobOpeningStatus.ON_HOLD],
    [JobOpeningStatus.CANCELLED]: [JobOpeningStatus.YET_TO_OPEN, JobOpeningStatus.OPEN, JobOpeningStatus.ON_HOLD],
}

/**
 * Returns the list of statuses allowed from the given current status.
 * Use for validation (API) and for filtering the status dropdown (UI).
 */
export function getAllowedNextStatuses(currentStatus: string): string[] {
    return ALLOWED_TRANSITIONS[currentStatus] ?? []
}

export function isAllowedStatusTransition(currentStatus: string, nextStatus: string): boolean {
    return getAllowedNextStatuses(currentStatus).includes(nextStatus)
}
